import React from "react";
import "./ServiceOffer.css";
import { FaPrint, FaHeadset, FaGlobe, FaMoneyBillWave } from "react-icons/fa";

const ServiceOffer = () => {
  const services = [
    {
      icon: <FaPrint />,
      title: "Printing Supplies",
      desc: "Toner cartridges, printers, and office essentials at competitive prices.",
    },
    {
      icon: <FaHeadset />,
      title: "After-Sales Support",
      desc: "24×7 maintenance and customer care for your peace of mind.",
    },
    {
      icon: <FaGlobe />,
      title: "Import Assistance",
      desc: "Struggling to source products? We’ll help you import them seamlessly.",
    },
    {
      icon: <FaMoneyBillWave />,
      title: "Cost Reduction Solutions",
      desc: "Smart strategies to cut your printing and office costs.",
    },
  ];

  return (
    <section className="service-sectionoffer">
       <h1 className="heading"> Products and Services </h1>
      <div className="service-container">
       
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3 className="service-card-title">{service.title}</h3>
            <p className="service-card-desc">{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceOffer;
